import { createMockComponent } from '~/tests/helpers/createMockComponent';

const MetdadataColumnHeaders = createMockComponent('MetadataColumnHeaders', 'metadata-column-headers');

export default MetdadataColumnHeaders;
